import { dateTimeFromServer } from '../utils/format'
import { JSON } from '../utils/types'
import { PaymentMethod } from './PaymentMethod'

export default class PicPay extends PaymentMethod {
  readonly qrCodeBase64Image: string
  readonly formattedExpirationDate: string

  constructor(data: JSON) {
    super(data)
    this.qrCodeBase64Image = data.qr_code_base64_image
    this.formattedExpirationDate = dateTimeFromServer(this.expirationDate, true)!
  }
}
